import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MyContext } from "../State/ProviderData";
import { loadUser } from "../requests";
import LogoXLtri from "../medias/logo_xltri_Calendrier2023.png";
import bookedEvents from "../medias/agenda-triathlons-orange.png";
import ImageWithText from "./ImageWithText";
import { jwtDecode } from "jwt-decode";

export const Navbar = (props) => {
  const { loggedIn, onLogout } = props;
  const [myData] = useContext(MyContext);
  const [userInfo, setUserInfo] = useState({});


  const fetchData = async () => {
  try {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      console.warn("No access token found");
      return;
    }

    const decodedToken = jwtDecode(token);

    if (!decodedToken?.sub) {
      console.warn("Invalid token payload");
      return;
    }

    const userResult = await loadUser(decodedToken.sub);
    setUserInfo(userResult);

  } catch (error) {
    console.error("fetchData error:", error);
  }
};
  // const fetchData = async () => {
  //   try {
  //     let token = "";
  //     token = localStorage.getItem("accessToken");

  //     const decodedToken = jwtDecode(token);
  //     const userResult = await loadUser(decodedToken.sub);
  //     setUserInfo(userResult);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //   fetchData();
  // }, [userInfo]);

  //const localBasket = localStorage.getItem("basket");
  // console.log(
  //   "this.state.basketItems",
  //   this.state.basketItems ? JSON.parse(this.state.basketItems).length : null
  // );

  if (loggedIn && userInfo && userInfo.role === "USER_ADMIN") {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-dark fixed-top mb-5 py-0">
        <div className="container">
          <Link to="/" className="mb-1">
            <img
              src={LogoXLtri}
              alt="Le calendrier des triathlons en France - XL Triathlon"
              className="d-md-none d-block"
              style={{ height: "60px" }}
            />
          </Link>
          <button
            className="navbar-toggler border-light bg-light"
            type="button"
            data-toggle="collapse"
            data-target="#main_nav"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <div className="float-right">
              <span className="navbar-toggler-icon text-light"></span>
            </div>
          </button>

          <div className="row collapse navbar-collapse" id="main_nav">
            <Link className="nav-item mr-4 text-white d-none d-md-block" to="/">
              <img
                src={LogoXLtri}
                alt="Le calendrier des triathlons en France - XL Triathlon"
                className="h-25"
              />
            </Link>

            <Link
              className="nav-item mr-4 text-white m-0 text-decoration-none hoverLink"
              to="/epreuves/new"
            >
              Ajouter une épreuve
            </Link>
            <Link
              className="nav-item mr-4 text-white m-0 text-decoration-none hoverLink"
              to="/epreuves/update"
            >
              Modifier une épreuve
            </Link>
            <Link
              className="nav-item mr-4 text-white m-0 align-left text-decoration-none hoverLink"
              to="/epreuves/compte"
            >
              Espace personnel
            </Link>

            <a
              className="nav-item mr-4 text-warning m-0 text-decoration-none hoverLink"
              onClick={onLogout}
            >
              Déconnexion
            </a>
          </div>
        </div>
        <ImageWithText
          imgSrc={bookedEvents}
          alt="Triathlons sélectionnés - XL Triathlon"
          className="mr-5"
          style={{ height: "50px" }}
          imgAlt={"Enregistrer une "}
          text={myData.filter((e) => e != null).length}
          data={myData.filter((e) => e != null)}
        />
        <span className="float-right d-none d-md-block">
          <h1 className="text-white font-weight-bold">Triathlon</h1>
        </span>
      </nav>
    );
  } else if (loggedIn) {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-dark fixed-top mb-5 py-0">
        <div className="container">
          <Link to="/">
            <img
              src={LogoXLtri}
              alt="Le calendrier des triathlons en France - XL Triathlon"
              className="d-md-none d-block"
              style={{ height: "60px" }}
            />
          </Link>
          <button
            className="navbar-toggler border-light bg-light"
            type="button"
            data-toggle="collapse"
            data-target="#main_nav"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <div className="float-right">
              <span className="navbar-toggler-icon text-light "></span>
            </div>
          </button>

          <div className="row p-0 collapse navbar-collapse pb-1" id="main_nav">
            <Link className="nav-item mr-4 text-white d-none d-md-block" to="/">
              <img
                src={LogoXLtri}
                alt="Le calendrier des triathlons en France - XL Triathlon"
                className="h-25"
              />
            </Link>
            <div className="mx-3">
              <Link
                className="nav-item mr-4 text-white text-decoration-none hoverLink"
                to="/triathlon/decouverte"
              >
                Découvrir
              </Link>
              <Link
                className="nav-item mr-4 text-white text-decoration-none hoverLink"
                to="/triathlon/performance"
              >
                Performer
              </Link>
              <Link
                className="nav-item mr-4 text-white text-decoration-none hoverLink"
                to="/triathlon/dompter"
              >
                Affronter ses peurs
              </Link>
              <Link
                className="nav-item mr-4 text-white text-decoration-none hoverLink"
                to="/triathlon/nature"
              >
                Pleine nature
              </Link>
              <Link
                className="nav-item mr-4 text-white m-0 align-left text-decoration-none hoverLink"
                to="/epreuves/compte"
              >
                Espace personnel
              </Link>

              <a
                className="nav-item mr-4 text-warning m-0 text-decoration-none hoverLink"
                onClick={onLogout}
              >
                Déconnexion
              </a>
            </div>
          </div>
          <ImageWithText
            imgSrc={bookedEvents}
            alt="Triathlons sélectionnés - XL Triathlon"
            className="mr-5"
            style={{ height: "50px" }}
            imgAlt={"Enregistrer une "}
            text={myData.filter((e) => e != null).length}
            data={myData.filter((e) => e != null)}
          />
          <span className="float-right d-none d-md-block">
            <h1 className="text-white font-weight-bold ">Triathlon</h1>
          </span>
        </div>
      </nav>
    );
  } else {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-dark fixed-top mb-5 py-0">
        <div className="container">
          <Link to="/">
            <img
              src={LogoXLtri}
              alt="Le calendrier des triathlons en France - XL Triathlon"
              className="d-md-none d-block"
              style={{ height: "60px" }}
            />
          </Link>
          <button
            className="navbar-toggler border-light bg-light"
            type="button"
            data-toggle="collapse"
            data-target="#main_nav"
            aria-controls="navbarNavAltMarkup"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <div className="float-right">
              <span className="navbar-toggler-icon text-light "></span>
            </div>
          </button>

          <div className="row p-0 collapse navbar-collapse pb-1" id="main_nav">
            <Link className="nav-item mr-4 text-white d-none d-md-block" to="/">
              <img
                src={LogoXLtri}
                alt="Le calendrier des triathlons en France - XL Triathlon"
                className="h-25"
              />
            </Link>
            <div className="mx-3">
              <Link
                className="nav-item mr-4 text-white text-decoration-none hoverLink"
                to="/triathlon/decouverte"
              >
                Découvrir
              </Link>
              <Link
                className="nav-item mr-4 text-white text-decoration-none hoverLink"
                to="/triathlon/performance"
              >
                Performer
              </Link>
              <Link
                className="nav-item mr-4 text-white text-decoration-none hoverLink"
                to="/triathlon/dompter"
              >
                Affronter ses peurs
              </Link>
              <Link
                className="nav-item mr-4 text-white text-decoration-none hoverLink"
                to="/triathlon/nature"
              >
                Pleine nature
              </Link>
              <Link
                className="nav-item text-white text-decoration-none hoverLink"
                to="/login"
              >
                Connexion
              </Link>
            </div>
          </div>
          <ImageWithText
            imgSrc={bookedEvents}
            alt="Triathlons sélectionnés - XL Triathlon"
            className="mr-5"
            style={{ height: "50px" }}
            imgAlt={"Enregistrer une "}
            text={myData.filter((e) => e != null).length}
            data={myData.filter((e) => e != null)}
          />
          <span className="float-right d-none d-md-block">
            <h1 className="text-white font-weight-bold ">Triathlon</h1>
          </span>
        </div>
      </nav>
    );
  }
};
